import { createSlice } from "@reduxjs/toolkit";

const drmDeleteTableDataSlice = createSlice({
  name: "deleteDrmtTableData",
  initialState: {
    sagaIds: [],
    isLoading: false,
    errorMessage: undefined,
    successMessage: undefined,
  },
  reducers: {
    setDeleteDrmTableData: (state) => {
      state.isLoading = true;
    },
    setDeleteDrmTableDataSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    setDeleteDrmTableDataFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    setResetDeleteDrmTableDataState: (state) => {
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    },
  },
});

export const {
  setDeleteDrmTableData,
  setDeleteDrmTableDataSuccess,
  setDeleteDrmTableDataFailure,
  setResetDeleteDrmTableDataState,
} = drmDeleteTableDataSlice.actions;

export default drmDeleteTableDataSlice.reducer;
